import * as yup from 'yup'

/** Схема формы ввода email без согласий (логин существующего юзера и привязка). */
export const emailOnlySchema = yup.object({
  email: yup
    .string()
    .trim()
    .lowercase()
    .email('Некорректный email')
    .required('Укажите email')
})

/** Схема регистрации: email + 3 чекбокса (оферта и ПД обязательные, реклама — нет). */
export const registrationSchema = yup.object({
  email: yup
    .string()
    .trim()
    .lowercase()
    .email('Некорректный email')
    .required('Укажите email'),
  agreedOffer: yup
    .boolean()
    .oneOf([true], 'Необходимо согласие с офертой')
    .required(),
  agreedPersonalData: yup
    .boolean()
    .oneOf([true], 'Необходимо согласие на обработку персональных данных')
    .required(),
  agreedAds: yup.boolean().required()
})

export type EmailOnlyValues = yup.InferType<typeof emailOnlySchema>
export type RegistrationValues = yup.InferType<typeof registrationSchema>
